module.exports = __webpack_public_path__ + "img/skyline.7c600853.jpg";